import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod";

export const mergeFulfillmentGroups = {
  name: "mergeFulfillmentGroups" as const,
  input: z.object({
    groupIds: z.array(z.string()),
    primaryGroupId: z.string(),
  }),
  output: z.object({ group: FulfillmentGroupDataSchema }),
};
